 
 export const Movies = [
        {
            name:'God and Man',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner2.png',
            image:'banner1.png',
            category:'Singles Seminar',
            language:'Twi',
            year:'2000',
            time:'2hr',
            video:'',
            rate:'5',
            reviews:'6.7k',
        },
        {
            name:'Seven Years of Gods Preparation',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner1.png',
            image:'banner2.png',
            category:'Crusade',
            language:'Twi',
            year:'2022',
            time:'30min',
            video:'',
            rate:'4',
            reviews:'6.7k',
        },
        {
            name:'Witchcraft Seed',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner5.png',
            image:'banner3.png',
            category:'Mpuntuo',
            language:'Twi',
            year:'2023',
            time:'1hr',
            video:'',
            rate:'3.4',
            reviews:'6.7k',
        },
        {
            name:'Protect Your Mind',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner1.png',
            image:'banner4.png',
            category:'Divine Hour',
            language:'Twi',
            year:'2019',
            time:'1hr 3min',
            video:'',
            rate:'3.4',
            reviews:'6.7k',
        },
        {
            name:'How to get a good marriage',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner3.png',
            image:'banner5.png',
            category:'Heaven FM',
            language:'Twi',
            year:'2020',
            time:'15min',
            video:'',
            rate:'2.5',
            reviews:'6.7k',
        },
        {
            name:'Right times to pray',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner5.png',
            image:'banner6.png',
            category:'Fruit of the womb',
            language:'Twi',
            year:'2024',
            time:'2hr',
            video:'',
            rate:'3.4',
            reviews:'6.7k',
        },
        {
            name:'The Mantle',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner3.png',
            image:'banner1.png',
            category:'Voice of healing',
            language:'Twi',
            year:'2021',
            time:'4hr',
            video:'',
            rate:'4.4',
            reviews:'6.7k',
        },
        {
            name:'Witchcraft In marriage',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner6.png',
            image:'banner1.png',
            category:'Elijah Tv',
            language:'Twi',
            year:'2018',
            time:'1hr 15min',
            video:'',
            rate:'4.4',
            reviews:'6.7k',
        },
        {
            name:'Witchcraft In marriage',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner6.png',
            image:'banner1.png',
            category:'Elijah Tv',
            language:'Twi',
            year:'2018',
            time:'1hr 15min',
            video:'',
            rate:'4.4',
            reviews:'6.7k',
        },
        {
            name:'Witchcraft In marriage',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner6.png',
            image:'banner1.png',
            category:'Elijah Tv',
            language:'Twi',
            year:'2018',
            time:'1hr 15min',
            video:'',
            rate:'4.4',
            reviews:'6.7k',
        },
        {
            name:'Witchcraft In marriage',
            desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley',
            titleImage:'banner6.png',
            image:'banner1.png',
            category:'Elijah Tv',
            language:'Twi',
            year:'2018',
            time:'1hr 15min',
            video:'',
            rate:'4.4',
            reviews:'6.7k',
        },
        
]